import { type MetaFunction } from '@remix-run/node'
import productFlood from './product-flood.png'

export const meta: MetaFunction = () => [
	{ title: 'Flood Insurance' },
	{
		name: 'description',
		content: 'We offer flood insurance.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Flood Insurance</h1>
			<img
				src={productFlood}
				alt="Homes and vehicles in a community where the ground is covered in water."
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The Federal Emergency Management Agency (FEMA) has created an insurance
				marketplace to serve the needs of millions of Americans who have
				suffered from water damage caused by flooding. FEMA regulates the flood
				mapping, which determines the flood zone of each home. The flood maps
				are updated periodically to more accurately reflect the risk of a flood
				incident.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Myth: I can't get flood insurance unless I live in an area with a severe
				flood risk.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Reality: Even if you live in an area with an extremely low risk of flood
				damage, you are probably still eligible to participate in the flood
				program. In fact, the premiums you pay are much lower than someone that
				lives in a high risk flood zone.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				I get asked this question a lot:
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				I don't have flood insurance now, but my bank is telling me that in
				order to refinance my home, I'll need to purchase flood insurance. Why?
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Since the flood maps are continuously being updated, your flood zone may
				have changed, your original loan may have been grandfathered in, or your
				bank's requirements may have changed. Consider inquiring with a
				different bank to see if they will have the same requirement. You may
				want to take this opportunity to consider the likelihood of a flood
				event and how it would impact you financially.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				FEMA flood policies have a maximum limit (at the time of this writing,
				it is $250,000 in coverage for your home and $100,000 for personal
				property contents) If these limits are not adequate, you may be able to
				get a secondary flood policy, referred to as an Excess Flood policy,
				that will complement the primary flood policy.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When I was 19 I visited Brazil for two years performing volunteer
				missionary service. At one point, a small town near where I lived was
				badly flooded. Several of us took a bus to that town to help with the
				cleanup efforts. I could not believe the amount of damage that was
				caused. The people there who were in the part of town that had the
				deepest flood water clearly were barely making ends meet. I'm certain
				that not one of them carried any form of insurance, let alone flood
				insurance. I have personally seen how damaging a flood can be.
			</p>
		</main>
	)
}
